import React from 'react';
import { MultiSelect } from 'primereact/multiselect';

// Denetleyici için çoklu ilçe + ilçeye göre gruplanmış çoklu mahalle seçimi (IP-536).
// Durum ve kayıt değerleri useIlceMahalleSecimi'nden gelir.
const IlceMahalleSecimi = ({ secim }) => {
  const {
    ilceSecenekleri,
    ilceYukleniyor,
    ilceler,
    ilceDegistir,
    mahalleGruplari,
    mahalleYukleniyor,
    mahalleler,
    mahalleDegistir,
    degisti,
    bulunamayanlar
  } = secim;

  const bulunamayanMetni = [
    bulunamayanlar.ilceler.length > 0 && `İlçe: ${bulunamayanlar.ilceler.join(', ')}`,
    bulunamayanlar.mahalleler.length > 0 && `Mahalle: ${bulunamayanlar.mahalleler.join(', ')}`
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <>
      <div className="form-group">
        <label htmlFor="ilce">İlçe</label>
        <MultiSelect
          id="ilce"
          value={ilceler}
          options={ilceSecenekleri}
          onChange={(e) => ilceDegistir(e.value)}
          optionLabel="name"
          optionValue="id"
          placeholder={ilceYukleniyor ? 'Yükleniyor...' : 'İlçe Seçiniz'}
          disabled={ilceYukleniyor || ilceSecenekleri.length === 0}
          filter
          display="chip"
          maxSelectedLabels={3}
          selectedItemsLabel="{0} ilçe seçildi"
          className="mahalle-multiselect"
        />
        {ilceler.length > 1 && (
          <p className="modal-helper-text">{ilceler.length} ilçe seçildi.</p>
        )}
      </div>
      <div className="form-group">
        <label htmlFor="mahalle">Mahalle</label>
        <MultiSelect
          id="mahalle"
          value={mahalleler}
          options={mahalleGruplari}
          onChange={(e) => mahalleDegistir(e.value)}
          optionGroupLabel="ilceAdi"
          optionGroupChildren="items"
          optionLabel="etiket"
          optionValue="anahtar"
          itemTemplate={(secenek) => secenek.ad}
          filterBy="ad"
          placeholder="Mahalle Seçiniz"
          disabled={!ilceler.length || mahalleGruplari.length === 0}
          filter
          display="chip"
          maxSelectedLabels={3}
          selectedItemsLabel="{0} mahalle seçildi"
          className="mahalle-multiselect"
        />
        {!ilceler.length && (
          <p className="modal-helper-text">Önce ilçe seçiniz.</p>
        )}
        {mahalleYukleniyor && (
          <p className="modal-helper-text">Mahalleler yükleniyor...</p>
        )}
        {mahalleler.length > 0 && (
          <p className="modal-helper-text">{mahalleler.length} mahalle seçildi.</p>
        )}
        {bulunamayanMetni && (
          <p className="modal-helper-text">
            Kayıtta olup listede bulunamayan: {bulunamayanMetni}.{' '}
            {degisti
              ? 'Kaydettiğinizde bu değerler silinecek.'
              : 'İlçe/mahalle seçimini değiştirmezseniz kayıt olduğu gibi kalır.'}
          </p>
        )}
      </div>
    </>
  );
};

export default IlceMahalleSecimi;
